<template>
  <el-container class="layout-container">
    <el-aside :width="isCollapse ? '80px' : '208px'" class="layout-aside">
      <NavMenu :collapseStatus="isCollapse" />
    </el-aside>
    <el-container style="min-width: 1000px;">
      <el-header height="auto" class="layout-header">
        <Header @isCollapseChange="isCollapseChange" />
      </el-header>
      <slot></slot>
    </el-container>
  </el-container>
</template>

<script>
import { defineComponent, ref } from 'vue'

import NavMenu from './NavMenu'
import Header from './Header'

export default defineComponent({
  name: 'Container',
  components: {
    NavMenu,
    Header
  },
  setup () {
    const isCollapse = ref(false)

    const isCollapseChange = (value) => {
      isCollapse.value = value
    }

    return {
      isCollapse,
      isCollapseChange
    }
  }
})
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100%;
}

.layout-aside {
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  z-index: 999;
  transition: width .2s linear 0s;
}

.layout-header {
  position: relative;
  padding: 0;
}
</style>
